import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import ElementUI from 'element-ui';
import VueLazyload from 'vue-lazyload'

import './theme/element/index.css'
import 'lib-flexible'

import router from './router'
import store from './store'

Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.prototype.isMobile=()=>{
  let facility = ""
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    // facility="app"
    axios.get('https://s.whte.cn/cippe/openWx')
    .then(function (response) {
      location.href = response.data.url
    })
    .catch(function (error) {
      console.log(error);
    });
    // this.$router.replace('/m_index');
  } else {
    facility="pc"
    // this.$router.replace('/pc_index');
  }
  return facility
}
Vue.prototype.webHerf=(url)=>{
  window.open(url,'_blank')
  // window.location.href = url
}
Vue.prototype.appHerf=(url)=>{
  // window.open(url,'_blank')
  window.location.href = url
}
Vue.prototype.isPath1=(that)=>{
  let path= that.$route.path.substr(1)
  
  const head = location.protocol.slice(0,-1)
  that.$store.dispatch('addPath',{path,head})
},
Vue.prototype.jump = (that)=>{
  if (!(store.state.user.isLogin)) {
    let path= that.$route.path.substr(1)
    const head = location.protocol.slice(0,-1)
    that.$store.dispatch('addPath',{path,head})
    that.$store.dispatch("dialog",true)
    return false
  }else if(store.state.user.user.status*1==0){
    that.$message({message: '请完善信息后浏览', type: 'warning',showClose: true,offset:100})
    that.$store.dispatch('information',true)
    this.$store.dispatch('informationState',true)
    return false
  }else{
    return true
  }
},
// 成功提示
Vue.prototype.success=(that,data)=>{that.$message({message: data,type: 'success',showClose: true,offset:100})},
// 错误提示
Vue.prototype.err=(that,data)=>{that.$message.error({message: data,showClose: true,offset:100})},
Vue.prototype.hrefurl = 'https://cippe-1302098519.cos.ap-beijing.myqcloud.com'

Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/loading.gif',
//   attempt: 2
//   })
Vue.use(ElementUI);
Vue.prototype.$jumpWeb=(url)=>{
  window.location.href = url
}

Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
